import {
  Typo3SectionSpotHeadlessPages,
  Typo3SectionSpotHeadlessPages_Item,
  Typo3SectionSpotSanityContentShop
} from '@/types/typo3'
import { SectionLinkProps } from '@/ui/Sections/SectionLink/type'

const toItem = (item: Typo3SectionSpotHeadlessPages_Item) => ({
  as: item?.link ? 'a' : 'div',
  title: item.title,
  subTitle: item.subtitle,
  target: item?.target,
  image: item?.media,
  href: item?.link,
  nextLink: item?.target === '_blank' ? false : true
})

const toSectionLink = (
  section: Typo3SectionSpotSanityContentShop | Typo3SectionSpotHeadlessPages
) => {
  if (section.type === 'spotsanity_content_shop') {
    return {
      section: section,
      title: section?.content?.title,
      titleLayout: section?.content?.titleLayout,
      buttons: section?.content?.buttons,
      gridInverted: section?.appearance?.layout === 'big-square-left',
      items: section?.content?.items?.map((item) => ({
        as: item?.link?.href ? 'a' : 'div',
        title: item.title,
        subTitle: item.lead,
        price: item?.priceText,
        tooltipText: item?.infoPrice,
        target: item?.link?.target,
        image: item?.images?.[0],
        href: item?.link?.href,
        nextLink: item?.link?.target === '_blank' ? false : true
      }))
    } as SectionLinkProps
  } else {
    return {
      title: section?.content?.title,
      titleLayout: section?.content?.titleLayout,
      gridInverted: section?.appearance?.layout === 'big-square-left',
      items:
        section?.content?.randomDisplay === true
          ? section?.content?.links
              ?.sort(() => Math.random() - 0.5)
              .map((item) => toItem(item))
          : section?.content?.links?.map((item) => toItem(item))
    } as SectionLinkProps
  }
}

export default toSectionLink
